import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IAppointments } from '../../services/availableTimes.service';

export interface GroupTimes {
  [key: string]: IAppointments;
}

export enum EScheduleSteps {
  'idle' = 'idle',
  'rescheduleAppointment' = 'rescheduleAppointment',
  'returnAppointment' = 'returnAppointment',
  'featuredAppointments' = 'featuredAppointments',
  'openCalendar' = 'openCalendar',
  'selectTime' = 'selectTime',
  'confirmSchedule' = 'confirmSchedule',
  'sendFile' = 'sendFile'
}

interface IScheduleState {
  dateStart: string;
  dateStartISO: string;
  selectedDay: string;
  confirm: boolean;
  events: string;
  haveToAnswerAnamnese: boolean;
  sendExams: boolean;
  finishReschedule: boolean;
  ui: {
    scheduling: 'idle' | 'initialize' | 'done';
    currentStep: EScheduleSteps;
    previousStep: EScheduleSteps;
    flow: EScheduleSteps;
    backToTop: number;
  };
}

const initialState: IScheduleState = {
  dateStart: '',
  dateStartISO: '',
  selectedDay: '',
  confirm: false,
  haveToAnswerAnamnese: false,
  sendExams: false,
  events: '',
  finishReschedule: false,
  ui: {
    scheduling: 'idle',
    currentStep: EScheduleSteps.idle,
    previousStep: EScheduleSteps.idle,
    flow: EScheduleSteps.idle,
    backToTop: 0
  }
};

export const scheduleSlice = createSlice({
  name: 'schedule',
  initialState,
  reducers: {
    saveSelectedDate: (state, action: PayloadAction<string>) => {
      state.dateStart = action.payload;
      state.dateStartISO = action.payload.length > 0 ? new Date(action.payload).toISOString() : ('' as string);
    },
    saveSelectedDay: (state, action) => {
      state.selectedDay = action.payload;
    },
    updateScheduleEvents: (state, action) => {
      state.events = action.payload;
    },
    saveConfirmSchedule: (state, action) => {
      state.confirm = action.payload;
    },
    updateScheduleSteps: (state, action: PayloadAction<{ currentStep: EScheduleSteps; previousStep?: EScheduleSteps }>) => {
      state.ui.currentStep = action.payload.currentStep;
      state.ui.previousStep = action.payload.previousStep || EScheduleSteps.idle;
    },
    initizalizeScheduleAppointment: (state, action: PayloadAction<{ currentStep: EScheduleSteps }>) => {
      state.ui.scheduling = 'initialize';
      state.ui.currentStep = action.payload.currentStep;
      state.ui.flow = action.payload.currentStep;
    },
    doneAnsweredAnamnese: (state, action) => {
      state.haveToAnswerAnamnese = action.payload;
    },
    doneSendExams: (state, action) => {
      state.sendExams = action.payload;
    },

    backToTopPage: state => {
      state.ui.backToTop += 1;
    },

    refreshSchedule: state => {
      state.confirm = false;
      state.finishReschedule = false;
    },
    doneReschedule: state => {
      state.finishReschedule = true;
      state.dateStart = '';
      state.dateStartISO = '';
      state.selectedDay = '';
      state.confirm = true;
      state.ui.scheduling = 'done';
      state.ui.currentStep = EScheduleSteps.idle;
      state.ui.previousStep = EScheduleSteps.idle;
      state.ui.flow = EScheduleSteps.idle;
    }
  }
});

export const {
  saveSelectedDate,
  saveSelectedDay,
  updateScheduleEvents,
  saveConfirmSchedule,
  updateScheduleSteps,
  initizalizeScheduleAppointment,
  doneAnsweredAnamnese,
  backToTopPage,
  doneSendExams,
  doneReschedule,
  refreshSchedule
} = scheduleSlice.actions;
export const scheduleReducer = scheduleSlice.reducer;
